import { useId } from "react";
import { MuscleDistribution } from "../../components/product";

// Builder-only collapsible wrapper around the shared read-only
// MuscleDistribution module.
//
// The builders need the WHOLE section collapsed by default so Workout
// Schedule is reachable without scrolling. That outer collapse is builder-owned
// presentation state and lives here.
//
// Once this panel owns the disclosure, the shared module's own "Show all /
// Show less" control is redundant, so the builders opt out of it via
// `showAllControl={false}` and every muscle row is revealed in one click. That
// prop is additive and defaults to true, so Cycle Viewer, Home and /program
// keep their existing Show all / Show less behaviour untouched.
export default function MuscleDistributionPanel({
  title,
  items,
  expanded,
  onExpandedChange,
  bodyId: suppliedBodyId,
  // Canonical weighted volume (see MuscleDistribution), passed through as is.
  volume = null,
}) {
  const generatedBodyId = `lz-builder-muscles-${useId().replace(/:/g, "")}`;
  const bodyId = suppliedBodyId || generatedBodyId;

  return (
    <section className="lz-builder-muscles">
      <button
        type="button"
        className="lz-builder-muscles__toggle min-h-[44px]"
        aria-expanded={expanded}
        aria-controls={bodyId}
        onClick={() => onExpandedChange(!expanded)}
      >
        <span className="lz-product-section-title">{title}</span>
        <svg
          className="lz-builder-muscles__chevron lz-builder-collapse-chevron"
          data-testid="builder-muscles-chevron"
          viewBox="0 0 16 16"
          aria-hidden="true"
        >
          <path d="M3.5 5.75 8 10.25l4.5-4.5" />
        </svg>
      </button>

      {/* The body stays mounted so the collapse can animate out as well as in;
          while collapsed it is visually hidden, inert and out of the a11y
          tree, so it behaves exactly as an unmounted body did. */}
      <div
        className="lz-builder-muscles__body lz-builder-collapse"
        id={bodyId}
        data-expanded={expanded ? "true" : "false"}
        aria-hidden={expanded ? undefined : "true"}
        inert={expanded ? undefined : ""}
      >
        <div className="lz-builder-collapse__inner">
          <MuscleDistribution
            title={title}
            items={volume ? volume.items : items}
            showAllControl={false}
            weighted={Boolean(volume)}
            unclassifiedSets={volume?.unclassifiedSets}
            status={volume?.status}
          />
        </div>
      </div>
    </section>
  );
}
